module.exports = __webpack_public_path__ + "static/fonts/NotoSansCJKkr-Medium.f3b7388.woff";